import { motion } from "framer-motion";

const partners = [
  { name: "Huawei", initial: "H" },
  { name: "Cisco", initial: "C" },
  { name: "Corning", initial: "CO" },
  { name: "Nokia", initial: "N" },
  { name: "CommScope", initial: "CS" },
  { name: "Motorola", initial: "M" },
  { name: "Ericsson", initial: "E" },
  { name: "ZTE", initial: "Z" },
];

export const Partners = () => {
  const doubled = [...partners, ...partners];

  return (
    <section data-testid="partners-section" className="py-20 bg-white border-t border-gray-100">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <span className="text-accent font-heading font-semibold text-sm tracking-widest uppercase block mb-3">
            Nuestros partners
          </span>
          <h2 className="font-heading font-bold text-primary text-3xl md:text-4xl mb-3">
            Trabajamos con las Mejores Marcas
          </h2>
          <p className="font-body text-gray-500 text-base">
            Tecnología de nivel mundial para cada proyecto
          </p>
        </motion.div>

        {/* Marquee */}
        <div className="overflow-hidden relative">
          {/* Fade edges */}
          <div className="absolute left-0 top-0 bottom-0 w-24 z-10 bg-gradient-to-r from-white to-transparent" />
          <div className="absolute right-0 top-0 bottom-0 w-24 z-10 bg-gradient-to-l from-white to-transparent" />

          <div className="flex animate-marquee gap-6 w-max">
            {doubled.map((partner, i) => (
              <div
                key={i}
                data-testid={`partner-${i}`}
                className="flex-shrink-0 flex items-center gap-3 bg-gray-50 hover:bg-accent/5 border border-gray-200 hover:border-accent/30 rounded-xl px-6 py-4 transition-all duration-300 group cursor-default min-w-[160px]"
              >
                <div className="w-10 h-10 bg-gradient-to-br from-primary to-accent rounded-lg flex items-center justify-center text-white font-heading font-black text-sm flex-shrink-0">
                  {partner.initial}
                </div>
                <span className="font-heading font-semibold text-gray-600 group-hover:text-primary transition-colors duration-200 text-sm">
                  {partner.name}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
